
/**
 * Module dependencies.
 */

import kycAndAml from 'client/markdown/en/kyc-and-aml.md';
import lawEnforcement from 'client/markdown/en/law-enforcement.md';
import privacy from 'client/markdown/en/privacy.md';
import termsOfService from 'client/markdown/en/terms-of-service.md';
import unitransferTermsOfService from 'client/markdown/en/terms-of-service-unitransfer.md';

/**
 * Export `en`.
 */

export default {
  kycAndAml,
  lawEnforcement,
  privacy,
  termsOfService,
  unitransferTermsOfService
};



// WEBPACK FOOTER //
// ../src/client/markdown/en/index.js